export default "__VITE_ASSET__DjblRhRM__"